"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarCompositionDTOSchema = void 0;
// src/dto/AvatarCompositionDTO.ts
const ETeam_1 = require("./ETeam");
const zod_1 = require("zod");
const AvatarCompositionDTOSchema = zod_1.z.object({
    teamColor: zod_1.z.nativeEnum(ETeam_1.ETeam),
    skin: zod_1.z.number(),
    hair: zod_1.z.number(),
    hair_color: zod_1.z.number(),
    eyes: zod_1.z.number(),
    nose: zod_1.z.number(),
    mouth: zod_1.z.number(),
    bonus: zod_1.z.number(),
});
exports.AvatarCompositionDTOSchema = AvatarCompositionDTOSchema;
